module.exports = {
    standard: 0,
    singlePassword: 1,
    passwordless: 2,
};


/** WEBPACK FOOTER **
 ** ./src/constants/password-mode.js
 **/